import { render, staticRenderFns } from "./MarketProductCard.vue?vue&type=template&id=56362dc0&"
import script from "./MarketProductCard.vue?vue&type=script&lang=js&"
export * from "./MarketProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports